var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.02344 0.5C1.29958 0.5 1.52344 0.723858 1.52344 1V6.2C1.52344 7.02843 2.19501 7.7 3.02344 7.7H11.8163L7.86988 3.75355C7.67462 3.55829 7.67462 3.24171 7.86988 3.04645C8.06515 2.85118 8.38173 2.85118 8.57699 3.04645L13.7305 8.2L8.57699 13.3536C8.38173 13.5488 8.06515 13.5488 7.86988 13.3536C7.67462 13.1583 7.67462 12.8417 7.86988 12.6464L11.8163 8.7H3.02344C1.64273 8.7 0.523438 7.58071 0.523438 6.2V1C0.523438 0.723858 0.747295 0.5 1.02344 0.5Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownRightArrow);
export default __webpack_public_path__ + "static/media/down-right-arrow.ed690d771c8d800a7aaa2689cb0270e1.svg";
export { ForwardRef as ReactComponent };